export default "__VITE_ASSET__ClW1RInh__"